export default "__VITE_ASSET__DERZ3FC9__"